import { Dropdown } from 'antd';
import styled from 'styled-components';

export default styled(Dropdown)`
	// Add your styles here
`;
